import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Input, OnInit } from '@angular/core';
import { AssetStatusLabels, AssetUIModel, ClientCoreModule, ClientEnvironment, ENVIRONMENT } from '@thehubz/client/core';
import { CustomClients } from '@thehubz/shared/branding';
import { AnyType, Metadata } from '@thehubz/shared/model';
import { AssetMetadata } from '../../../../../models/asset-info.interface';

@Component({
  selector: 'thehubz-lufthansa-asset-metadata',
  templateUrl: './lufthansa-asset-metadata.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, ClientCoreModule],
})
export class LufthansaAssetMetadataComponent implements OnInit {
  @Input() assetInfoObject!: AssetMetadata;
  @Input() asset!: AssetUIModel;

  [key: string]: AnyType;

  metadata?: AnyType;
  dateCreated?: string;
  durationString?: string;
  assetStatusLabels = AssetStatusLabels;
  brandingKey!: CustomClients;

  constructor(@Inject(ENVIRONMENT) env: ClientEnvironment) {
    this.brandingKey = env.brandingKey ?? CustomClients.Standard;
  }

  ngOnInit(): void {
    const version = this.asset.currentVersion;
    const defaultRatio = version?.aspectRatios?.find((ar) => ar.aspectRatio === version.defaultAspectRatio);
    const mainFile = defaultRatio?.formats?.find((f) => f.fileNameRef === defaultRatio.defaultFileFormat);
    this.metadata = Metadata(mainFile?.metadata);

    this.dateCreated = this.metadata.dateCreated ?? this.asset.createdAt;
    this.durationString = this.metadata.getDuration();
  }

  callPipe(assetObj: AnyType) {
    let inputString = '';
    if (assetObj.propertyObject) {
      inputString = this.asset[assetObj.propertyObject][assetObj.formControlName];
    } else if (assetObj.directValue) {
      inputString = this[assetObj.formControlName];
    } else {
      inputString = this.asset[assetObj.formControlName];
    }
    return assetObj.pipe.transform(inputString, { plainDate: true });
  }

  getComponentVariable(assetObj: AnyType) {
    return this[assetObj.formControlName];
  }
}
